import { GraphQLClient } from 'graphql-request';

const cmsGQLClient = new GraphQLClient(process.env.REACT_APP_HYGRAPH_API_URL, {
  headers: {
    authorization: `Bearer ${process.env.REACT_APP_HYGRAPH_AUTH_TOKEN}`,
  },
});

export default cmsGQLClient;
